/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import {
  setBodyEvents,
  setEvents,
  setMixEvents,
  setConfirmData,
} from "../../common/actions/common.actions";
import shoeIcon from "../../../assets/newIcons/sports-video-intersound.png";
import football from "../../../assets/newIcons/football2.png";
import HistoryIco from "../../../assets/newIcons/time-machine.png";
import Soccer from "../../../assets/newIcons/scoreboard.png"
import Credit from "../../../assets/newIcons/credit.png";
import onGoing from "../../../assets/newIcons/play.png";
import dashboardService from "../../../api/services/dashboardService";
import withAuth from "../../common/hoc/withAuth";
import PopupModal from "./popupModal";
import { useTranslation } from "react-i18next";
import { selectLoginData } from "../login/login.actions";
import signalRConnection from "../../../signalR/signalRService";
import { setOpen } from "../../common/components/sidebar/sidebar.actions";

const TABS = [
  { labelKey: "maungg", icon: shoeIcon, path: "/maungg" },
  { labelKey: "body", icon: football, path: "/body" },
  { labelKey: "matches", icon: onGoing, path: "/selected-matches" },
  { labelKey: "oldHistories", icon: HistoryIco, path: "/old-histories" },
  { labelKey: "transaction", icon: Credit, path: "/transactions" },
  { labelKey: "result", icon: Soccer, path: "/goal-score" },
];

function Dashboard({ setShowSideBar, setIsLoading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [displayTextArr, setDisplayTextArr] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { userDetails } = useSelector(selectLoginData);
  const [userBalance, setUserBalance] = useState(userDetails?.balance);
  const [refresh, setRefresh] = useState(false);

  

  useEffect(() => {
    const handleChangedBalance = async () => {
      await updateUserBalance(userDetails);
    };
    signalRConnection.on("changedBalance", handleChangedBalance);
    return () => {
      signalRConnection.off("changedBalance", handleChangedBalance);
    };
  }, [userDetails]);

  useEffect(() => {
    const initData = async () => {
      try {
        dispatch(setConfirmData(null));
        const data = await dashboardService
          .getDisplayTextForDashboard()
          .then((res) => res.json());
        setDisplayTextArr(data);
        await updateUserBalance(userDetails);
      } catch (error) {
        console.error(error);
      }
    };

    initData();
    dispatch(setMixEvents([]));
    dispatch(setBodyEvents([]));
    dispatch(setEvents([]));
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails?.balance) setUserBalance(storedUserDetails.balance);
  }, [refresh]);

  const updateUserBalance = async (user) => {
    if (!user?.userId) return;
    try {
      const userId = Number(user.userId);
      const res = await dashboardService
        .getBalanceForDashboard(userId)
        .then((res) => res.json());
      if (res?.userInfo?.length) {
        setUserBalance(res.userInfo[0]?.balance);
        localStorage.setItem("userDetails", JSON.stringify(res.userInfo[0]));
      }
    } catch (error) {
      console.error("Error updating user balance:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/20 relative">

      {/* Popup Modal */}
      <PopupModal
        data={displayTextArr}
        isPopupOpen={isPopupOpen}
        setIsPopupOpen={setIsPopupOpen}
      />

      {/* Main Content */}
      <div className="relative z-10 mx-auto max-w-7xl">
        {/* Welcome Section */}
        <div className="mb-4">
          <div className="bg-gradient-to-r from-primary via-emerald-600 to-[#1F5F1F] text-white">
            {/* Header Row - Menu and Balance */}
            <div className="flex items-center justify-between px-6 py-2 bg-black/10">
              <button
                onClick={() => dispatch(setOpen())}
                className="p-3 rounded-xl bg-white/20 active:bg-white/30"
                aria-label="Toggle navigation menu"
              >
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"/>
                </svg>
              </button>

              <div className="flex items-center space-x-3">
                <div className="text-right">
                  <p className="text-xs font-medium text-emerald-100">Balance</p>
                  <p className="text-xl font-bold text-white">
                    {parseInt(userBalance).toLocaleString()} Ks
                  </p>
                </div>
                <button
                  onClick={() => {
                    setRefresh(true);
                    setTimeout(() => setRefresh(false), 1500);
                  }}
                  className="p-3 rounded-xl bg-white/20 active:bg-white/30"
                  aria-label="Refresh Balance"
                >
                  <svg className={`w-5 h-5 text-white ${refresh ? "animate-spin" : ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Welcome Content */}
            <div className="relative px-6 py-4">
              <div className="relative z-10">
                <h1 className="text-xl font-bold text-white sm:text-2xl">
                  Welcome back, {userDetails?.username || 'User'}!
                </h1>
                <p className="mb-2 text-sm font-medium text-emerald-100">
                  Ready to place your next winning bet?
                </p>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 rounded-full bg-emerald-300"></div>
                  <span className="text-xs text-emerald-200">Football betting available</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Announcement Banner */}
        <div className="mb-6">
          <div
            className="flex items-center px-4 py-3 mx-4 bg-white/80 shadow-sm rounded-2xl border border-gray-200 active:bg-white/90"
            onClick={() => setIsPopupOpen(true)}
          >
            <div className="flex-shrink-0 w-3 h-3 mr-3 rounded-full bg-gradient-to-r from-blue-500 to-purple-500"></div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center mb-1">
                <span className="px-2 py-0.5 text-xs font-bold text-blue-600 bg-blue-100 rounded-full">Announcement</span>
              </div>
              <Marquee className="text-sm font-semibold text-gray-800">
                {displayTextArr.map((d) => d.displayText).join(" • ")}
              </Marquee>
            </div>
          </div>
        </div>

        {/* Navigation Grid */}
        <div className="mx-4 mb-8">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl font-bold text-gray-900">Quick Actions</h2>
              <p className="text-xs text-gray-600">Choose your next move</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {TABS.map(({ labelKey, icon, path }, index) => (
              <button
                key={path}
                onClick={() => navigate(path)}
                className={`rounded-2xl text-white px-4 py-5 active:opacity-90 ${
                  index % 6 === 0 ? 'bg-[#228B22]' :
                  index % 6 === 1 ? 'bg-[#1E90FF]' :
                  index % 6 === 2 ? 'bg-[#fc09e0]' :
                  index % 6 === 3 ? 'bg-[#FF4500]' :
                  index % 6 === 5 ? 'bg-[#228B22]' :
                  'bg-[#1E90FF]'
                }`}
                aria-label={t(labelKey)}
              >
                <div className="flex items-center">
                  <div className="flex items-center justify-center w-8 h-8 bg-white bg-opacity-20 rounded-xl">
                    <img
                      src={icon}
                      alt={t(labelKey)}
                      className="w-4 h-4 filter brightness-0 invert"
                    />
                  </div>

                  <div className="flex flex-col ml-2 text-left">
                    <h3 className="text-sm leading-tight font-semibold">
                      {t(labelKey)}
                    </h3>
                    <p className="text-xs leading-relaxed opacity-80">
                      {labelKey === 'maungg' && 'Live Football'}
                      {labelKey === 'body' && 'Body Goal'}
                      {labelKey === 'matches' && 'Your Picks'}
                      {labelKey === 'oldHistories' && 'Past Bets'}
                      {labelKey === 'transaction' && 'Payments'}
                      {labelKey === 'result' && 'Live Score'}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>

          
        </div>

      </div>

    </div>
  );
}

export default withAuth(Dashboard);
